/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Side_TitleInputs */

const en_us2_profile_editors_side_title = /** @type {(inputs: Profile_Editors_Side_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which is your dominant side?`)
};

const pt_br2_profile_editors_side_title = /** @type {(inputs: Profile_Editors_Side_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o seu lado dominante?`)
};

const es_419_profile_editors_side_title = /** @type {(inputs: Profile_Editors_Side_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es tu lado dominante?`)
};

const pt_pt2_profile_editors_side_title = /** @type {(inputs: Profile_Editors_Side_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o teu lado dominante?`)
};

const fr_fr2_profile_editors_side_title = /** @type {(inputs: Profile_Editors_Side_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est ton côté dominant ?`)
};

const de_de2_profile_editors_side_title = /** @type {(inputs: Profile_Editors_Side_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche ist deine dominante Seite?`)
};

const it_it2_profile_editors_side_title = /** @type {(inputs: Profile_Editors_Side_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è il tuo lato dominante?`)
};

/**
* | output |
* | --- |
* | "Which is your dominant side?" |
*
* @param {Profile_Editors_Side_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_side_title = /** @type {((inputs?: Profile_Editors_Side_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Side_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_side_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_side_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_side_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_side_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_side_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_side_title(inputs)
	return en_us2_profile_editors_side_title(inputs)
});
export { profile_editors_side_title as "profile-editors.side_title" }